import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CardContent, Grid, Tooltip } from '@mui/material';
import { AgChartOptions } from 'ag-charts-community';
import { AgCharts } from 'ag-charts-react';
import CenteredSpinner from 'components/Loading/CenteredSpinner';
import React from 'react';
import { SmallTitle } from 'styles/styles';

import { Card, CardTooltip } from './styles';

interface ChartCardProps {
  chartOptions: AgChartOptions;
  loading?: boolean
  title: React.ReactNode;
  tooltip?: React.ReactNode;
}

function ChartCard(props: ChartCardProps) {
  const {
    chartOptions,
    loading,
    title,
    tooltip,
  } = props;

  return (
    <Card elevation={0}>
      <CardContent>
        <Grid container item gap={1}>
          <SmallTitle>
            {title}
          </SmallTitle>
          {tooltip && (
            <Tooltip arrow title={tooltip}>
              <CardTooltip>
                <FontAwesomeIcon icon={faInfoCircle} />
              </CardTooltip>
            </Tooltip>
          )}
        </Grid>
        {loading ? <CenteredSpinner /> : <AgCharts options={chartOptions} />}
      </CardContent>
    </Card>
  );
}

export default ChartCard;
